import React from "react";
import { Container, Row, Col } from "reactstrap";
import styles from "./RefundDetail.module.scss";
import InfoCard from "../../../../common/AdminCommonComponents/InfoCard/InfoCard";
import ComponentBackButton from "../../../../common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton";
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";

const RefundDetail = ({ setShowReturnDetails }) => {
    const generalInfoData = [
        { label: "Refund ID", value: "#1234" },
        { label: "Return ID", value: "#123" },
        { label: "Seller ID", value: "#1234" },
        { label: "Customer Name", value: "Full Name" },
        { label: "Customer Phone No.", value: "03417053723" },
        { label: "Refund Amount", value: "$50.00" },
        { label: "Refund Status", value: "Shipped" },
    ];

    const transactionData = [
        { label: "Date of Initiation", value: "01/01/2025  03:24 AM" },
        { label: "Payment Method", value: "Bank Account" },
    ];

    const logsHistoryData = [
        { label: "01/01/2025  03:24 AM", value: "Accepted request" },
        { label: "01/01/2025  03:24 AM", value: "Initiated Refund" },
        { label: "01/01/2025  03:24 AM", value: "Refunded" },
    ];

    return (
        <div className={styles.mainContainer}>
            <Container fluid className={styles.orderDetailWrapper}>
                <ComponentBackButton onClick={() => setShowReturnDetails(false)} />
                <h4 className={styles.mainHeading}>Refund Tracking</h4>
                <Row className={styles.infoCardRow}>
                    <Col>
                        <InfoCard title="General Information" headerColor="#FBBD34" data={generalInfoData} />
                    </Col>
                    <Col>
                        <InfoCard title="Transaction Details" headerColor="#EC7426" data={transactionData} />
                    </Col>
                    <Col>
                        <InfoCard title="Logs and History" headerColor="#41B8E4" data={logsHistoryData} />
                    </Col>
                </Row>
                <Row className={styles.btnsRow}>
                    <Col xl={3}>
                        <div className={styles.btnsContainer}>
                            <DynamicButton theme="sky-blue">Initiate Refund</DynamicButton>
                            <DynamicButton theme="orange">Approve/Reject</DynamicButton>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default RefundDetail;